import DutyModal from './DutyModal'

export default DutyModal
